import { StoreAction, XmAction } from 'store/actions';
import { NowAccountBadgesCollection } from './models/badges';

export function nowAccountBadgesReducer(state: NowAccountBadgesCollection, action: XmAction<NowAccountBadgesCollection>): NowAccountBadgesCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_ACCOUNT_BADGES:
            return action.payload;
        default:
            return state;
    }
}

